import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  EntityModel,
  trackEvent,
  useCurrentClientManager,
  useClientContext,
} from '@cko/dashboard-shared';

import { useNotifications } from '../../../../contexts/NotificationsProvider';
import { ItemView } from '../ItemView';
import { NotificationItemComponentProps } from '../types';

type Props = NotificationItemComponentProps;

export const NavigationItem = ({ closeList, notification }: Props) => {
  const history = useHistory();
  const {
    actions: { changeView },
    client,
    entity,
    segment,
  } = useCurrentClientManager();
  const { getClient } = useClientContext();
  const { updateNotificationReadStatus } = useNotifications();

  const handleItemViewClick = async () => {
    trackEvent('Click - in-dashboard notifications - notification item', {
      dashboardActionType: notification.dashboardAction.type,
      notificationType: notification.notificationType,
    });

    if (!notification.isRead) {
      await updateNotificationReadStatus(notification.eventId, true);
    }

    const isSamePath = notification.dashboardAction.href === history.location.pathname;
    const isSameClient = notification.clientId === client.id;
    const isSameEntity = notification.entityId && notification.entityId === entity?.id;

    if (isSamePath && isSameClient && isSameEntity && !segment) {
      closeList();
      return;
    }

    if (
      !segment &&
      ((entity && isSameEntity) || (!entity && isSameClient && !notification?.entityId))
    ) {
      closeList();
      history.push(notification.dashboardAction.href);
      return;
    }

    const newClient = await getClient(notification.clientId);
    const newEntity =
      newClient && notification.entityId
        ? newClient.entities.find(
            (newClientEntity: EntityModel) => newClientEntity.id === notification.entityId,
          )
        : undefined;
    const updatedView = await changeView({
      client: newClient,
      entity: newEntity,
    });
    if (updatedView) {
      closeList();
      history.push(notification.dashboardAction.href);
    }
  };

  return <ItemView notification={notification} onClick={handleItemViewClick} />;
};
